"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.newILendingPool = exports.ABI = void 0;
exports.ABI = [
    {
        inputs: [{ internalType: "address", name: "_reserve", type: "address" }],
        name: "getReserveData",
        outputs: [
            { internalType: "uint256", name: "totalLiquidity", type: "uint256" },
            { internalType: "uint256", name: "availableLiquidity", type: "uint256" },
            { internalType: "uint256", name: "totalBorrowsStable", type: "uint256" },
            {
                internalType: "uint256",
                name: "totalBorrowsVariable",
                type: "uint256",
            },
            { internalType: "uint256", name: "liquidityRate", type: "uint256" },
            { internalType: "uint256", name: "variableBorrowRate", type: "uint256" },
            { internalType: "uint256", name: "stableBorrowRate", type: "uint256" },
            {
                internalType: "uint256",
                name: "averageStableBorrowRate",
                type: "uint256",
            },
            { internalType: "uint256", name: "utilizationRate", type: "uint256" },
            { internalType: "uint256", name: "liquidityIndex", type: "uint256" },
            { internalType: "uint256", name: "variableBorrowIndex", type: "uint256" },
            { internalType: "address", name: "aTokenAddress", type: "address" },
            { internalType: "uint40", name: "lastUpdateTimestamp", type: "uint40" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getReserves",
        outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_reserve", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
            { internalType: "uint16", name: "_referralCode", type: "uint16" },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
function newILendingPool(web3, address) {
    return new web3.eth.Contract(exports.ABI, address);
}
exports.newILendingPool = newILendingPool;
//# sourceMappingURL=ILendingPool.js.map